import React from "react";

export interface WeeklyInsightItem {
  accent: "error" | "success" | "brand";
  label: string;
  title: string;
  description: string;
}

export interface WeeklyCashMovementInsightsPanelProps {
  insights: WeeklyInsightItem[];
  loading?: boolean;
}

const borderClass: Record<WeeklyInsightItem["accent"], string> = {
  error: "border-l-error-500",
  success: "border-l-success-500",
  brand: "border-l-brand-500",
};

const labelClass: Record<WeeklyInsightItem["accent"], string> = {
  error: "text-error-500",
  success: "text-success-500",
  brand: "text-brand-500",
};

export function WeeklyCashMovementInsightsPanel({
  insights,
  loading = false,
}: WeeklyCashMovementInsightsPanelProps) {
  if (loading) {
    return (
      <div className="flex h-full min-h-0 w-full flex-col gap-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="flex min-h-0 w-full flex-1 flex-col gap-2 rounded-lg border-2 border-solid border-neutral-border bg-default-background px-4 py-4 animate-pulse"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-4">
      {insights.map((item, i) => (
        <div
          key={i}
          className={`flex min-h-0 w-full flex-1 flex-col items-start justify-start gap-2 rounded-lg border-2 border-solid border-neutral-border bg-default-background px-4 py-4 ${borderClass[item.accent]}`}
        >
          <span
            className={`font-['Inter'] text-[10px] font-[700] leading-[15px] tracking-wide uppercase ${labelClass[item.accent]}`}
          >
            {item.label}
          </span>
          <span className="text-body-bold font-body-bold text-default-font">
            {item.title}
          </span>
          <span className="text-caption font-caption text-neutral-400">
            {item.description}
          </span>
        </div>
      ))}
    </div>
  );
}
